module.exports = __webpack_public_path__ + "img/web-solution-white.938da170.svg";